module.exports = __webpack_public_path__ + "static/media/letterTemplate.4c338e5d.png";